<template>
  <div class="cadfm-container-horizontal">
    <!-- <Left  v-show="isVisibleLeft&&!isPlugin" :lang="lang.Left"></Left> -->
    <Left  v-show="isVisibleLeft" :lang="lang.Left"></Left>
    <Middle  :lang="lang.Middle"></Middle>
    <Right v-show="isVisibleRight" :lang="lang.Right"></Right>
 </div>
</template>

<script>
import Left from '@/components/PartManager/Views/PartTable/Left/Left'
import Middle from '@/components/PartManager/Views/PartTable/Middle/Middle'
import Right from '@/components/PartManager/Views/PartTable/Right/Right'
import { mapGetters } from 'vuex'

export default {
  name: 'PartTable',
  components:{
    Left,
    Middle,
    Right
  },
 props:{
    
    lang: Object
  },
  computed:{
    ...mapGetters([
        'isPlugin',
       
      ]),
  },
  data () {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    }
  },
  mounted () {
    //this.setCategory();
  },
  methods: {
    
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartTable.vue